import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useCartMiniContext } from "../../../../contexts/CartMiniContext";
import { useLoyaltyProductPoints } from "../../../../hooks/useLoyaltyProductPoints";
import { useLoyaltyStatus } from "../../../../hooks/useLoyaltyStatus";
import { CartMiniItems } from "../../components/CartMiniItems";
import { CartMiniPointsBlock } from "../../components/CartMiniPointsBlock";
import styles from "./CartMiniContent.module.scss";
export const CartMiniContent = ({ pending, items, qtyPending, buyLimitation, onRemoveItemClick, onItemQuantityChange, onRemoveItems, }) => {
    const hasLoyalty = useLoyaltyStatus();
    const totalLoyaltyPoints = useLoyaltyProductPoints(items);
    const { isDarkTheme } = useCartMiniContext();
    const contentClasses = classNames(styles.contentContainer, {
        [styles.dark]: isDarkTheme,
        [styles.empty]: !(items?.length > 0),
    });
    return (_jsxs("div", { className: contentClasses, children: [_jsx(CartMiniItems, { pending: pending, items: items, qtyPending: qtyPending, buyLimitation: buyLimitation, onRemoveItemClick: onRemoveItemClick, onItemQuantityChange: onItemQuantityChange, onRemoveItems: onRemoveItems }), _jsx(CartMiniPointsBlock, { totalPoints: totalLoyaltyPoints, pending: pending, isActive: hasLoyalty })] }));
};
//# sourceMappingURL=CartMiniContent.js.map